import React from 'react';
import {Form, Edit, Suggestions, List} from 'components';
import {useNamedSelector} from 'helpers';

export function StrengthsInquiry1() {
  return (
    <Form {...useNamedSelector('identity.form', { name: 'strengths-inquiry-1' })}>
      <List tiny-gutter>
        <p>Ask yourself and your closest friends the following questions. Notice how it feels to answer these questions and whether any of your friends' responses surprise you:</p>
        <List.Title>What are you good at?</List.Title>
        <Edit name="1" Suggestions={Suggestions.Strengths} />
        <List.Title>What do people compliment you on?</List.Title>
        <Edit name="2" Suggestions={Suggestions.Strengths} />
        <List.Title>What do you do better than most others?</List.Title>
        <Edit name="3" Suggestions={Suggestions.Strengths} />
        <List.Title>What are your natural gifts and talents?</List.Title>
        <Edit name="4" Suggestions={Suggestions.Strengths} />
        <List.Title>What comes naturally to you?</List.Title>
        <Edit name="5" Suggestions={Suggestions.Strengths} />
        <List.Title>What do you like most about yourself?</List.Title>
        <Edit name="6" Suggestions={Suggestions.Strengths} />
        <List.Title>What are you proud of?</List.Title>
        <Edit name="7" Suggestions={Suggestions.Strengths} />
        <List.Title>What do people who know you well say are your most positive or special qualities and personal attributes?</List.Title>
        <Edit name="8" Suggestions={Suggestions.Strengths} />
        <Edit name="9" Suggestions={Suggestions.Strengths} />
        <Edit name="10" Suggestions={Suggestions.Strengths} />
      </List>
    </Form>
  );
}
